// Keep only the latest reservation per merchant on this device. Provider
// credentials and payment artifacts are never persisted.

const PREFIX = 'sp:reservation:';

export function reservationStorageKey(slug) {
  return `${PREFIX}${slug}`;
}

export function readSavedReservation(slug, storage = window.localStorage) {
  try {
    const raw = storage.getItem(reservationStorageKey(slug));
    if (!raw) return null;
    const reservation = JSON.parse(raw);
    if (
      !reservation ||
      typeof reservation !== 'object' ||
      !reservation.id ||
      (!reservation.reservationToken && !reservation.bookingCode)
    ) {
      return null;
    }
    return reservation;
  } catch {
    return null;
  }
}

export function saveReservation(slug, reservation, storage = window.localStorage) {
  try {
    const { publicKey: _publicKey, nextAction: _nextAction, ...safeReservation } = reservation;
    storage.setItem(reservationStorageKey(slug), JSON.stringify(safeReservation));
  } catch {
    // Storage can be disabled or full. The in-memory confirmation remains
    // usable, so persistence is intentionally best-effort.
  }
}

export function clearSavedReservation(slug, storage = window.localStorage) {
  try {
    storage.removeItem(reservationStorageKey(slug));
  } catch {
    // Best effort, matching saveReservation.
  }
}
